import {
    Button,
    Box,
    Container,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Input,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    FormControl,
    FormLabel,
    FormHelperText,
    FormErrorMessage,
    useColorModeValue,
    Link,
    useToast, chakra
} from "@chakra-ui/react";

import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react'

import {Header as Nav} from "../header/Header";
import {Footer} from "../footer/Footer";
import {Form, redirect, useNavigate, useParams, useLocation  } from "react-router-dom";
import React, {useState} from "react";

import Cookies from 'js-cookie';
import {EmailInputEvo} from "../forms/chakra/inputs/EmailInputEvo";
// import {EmailInputEvo} from "../components/forms/chakra/inputs/EmailInputEvo";
import {FormControlEvo} from "../forms/chakra/FormControlEvo";
import {ScreenContainer} from "../container/ScreenContainer";
import {useEvoContext} from "../../context/evo.context";
import DataProviderEvo from "../../components/dataProviderEvo/evo-data-provider";
import LoginDataProvider from "../../components/dataProviderEvo/login-data-provider";
import {ROUTE_PURCHASE, ROUTE_MAIN, ROUTE_PASSWORD_RESET} from "../../App";

export default function Login() {

    const navigate = useNavigate();
    const {userId, setAuthToken, setUserId, isLoggedIn, setPwdHash, setEmail} = useEvoContext();
    const toast = useToast();

    if(isLoggedIn){
        navigate('/');
    }

    // const { nakup } = useParams();
    const query = new URLSearchParams(useLocation().search);
    const nakup = query.get('nakup');

    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const [errors, setErrors] = useState({ email: '', password: '' });

    const validateForm = () => {
        const newErrors = {};

        let emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }

        if (!formData.password) {
            newErrors.password = 'Password is required';
        }

        setErrors(newErrors);

        // Returns true if no errors found
        return Object.keys(newErrors).length === 0;
    };



    // Handle form input changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission


        if (validateForm()) {
            setEmail(formData.email);
            setPwdHash(btoa(formData.password));
        }
    };



    return (
        <Box bg={useColorModeValue('#f9f9f9', '#1a202c')}>
            <Nav />
            <ScreenContainer>
                <Stack direction={{ base: 'column', md: 'column' }}>
                    <Flex flex={1} align={'center'} justify={'center'}>

                        <Stack direction={{base: 'column', md: 'column'}}>
                            <Flex flex={1} align={'center'} justify={'center'}>
                                <Stack spacing={6} w={'full'}>
                                    <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                                        Přihlásit se
                                    </chakra.h1>
                                </Stack>
                            </Flex>

                        </Stack>
                    </Flex>

                </Stack>
                <Box bg={"white"} mt={"5"}  padding={"10"} mt={5} boxShadow={"md"} borderRadius={10}>
                    <Form method={"post"} onSubmit={handleSubmit} >
                        <EmailInputEvo validity={errors.email} defaultVal={formData.email} handleChange={handleChange} />
                        <FormControlEvo>
                            <FormLabel>
                                Heslo
                                <span style={{ color: 'red', paddingLeft: "5px" }}>*</span>
                            </FormLabel>
                            <Input defaultValue={formData.password} type={"password"} name={"password"}  isInvalid={!!errors.password} onChange={handleChange} />
                            <FormControlEvo>
                                <FormHelperText>
                                    <Link fontWeight={"semibold"} fontSize="md" href={ROUTE_MAIN + ROUTE_PASSWORD_RESET} color="blue.500">
                                        Zapomenuté heslo
                                    </Link>
                                </FormHelperText>
                             </FormControlEvo>
                        </FormControlEvo>
                        <FormControlEvo>
                            <Button colorScheme='pink' variant='solid' type={"submit"}>Přihlásit se</Button>
                        </FormControlEvo>
                    </Form>

                    <Stack spacing={3} fontWeight={"bold"} alignContent={"center"} alignItems={"center"}>
                        <Text fontSize='xl'>Nemáte účet?  <Link  fontSize="xl" href={"registrace"} color="blue.500">
                            Zaregistrovat se
                            </Link>
                        </Text>
                    </Stack>
                </Box>
            </ScreenContainer>
            <Footer />
        </Box>
    )
}